module.exports = __webpack_public_path__ + "img/monitor03.b983cb79.png";